import {Flex, Progress, Table as TableAnt} from 'antd';
import {ColumnsType} from 'antd/es/table/interface';
import React from 'react';

import {defaultCol} from '../../../../../components/Table/Interface/ITable';

interface DataType {
  key: React.Key;
}

const ActionItems: React.FC<{dataSource: any[]}> = ({dataSource}) => {
  const columns: Array<defaultCol & ColumnsType<DataType>[0]> = [
    {dataIndex: 'section', title: 'Sections'},
    {dataIndex: 'subSection', title: 'Sub-Section'},
    {
      dataIndex: 'percentage',
      title: 'Progress Trackers',
      width: 300,
      render: (value) => {
        return (
          <Flex vertical>
            <div
              style={{
                alignSelf: 'flex-end',
                color: '#2E2A2A',
                textAlign: 'right',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '120%'
              }}
            >
              {!isNaN(value) ? `${value}%` : '0%'}
            </div>
            <Progress
              percent={value}
              showInfo={false}
              trailColor="#B1C4CF"
              strokeColor="#024064"
            />
          </Flex>
        );
      }
    }
    // {
    //   dataIndex: 'action',
    //   title: 'Details',
    //   render: () => {
    //     return <Button type="link">Notify</Button>;
    //   }
    // }
  ];

  return (
    <div
      style={{
        flex: '1',
        borderRadius: '8px',
        border: '1px solid #D2D4DA',
        padding: '14px 15px',
        maxHeight: '280px',
        overflowY: 'hidden'
      }}
    >
      <TableAnt
        dataSource={dataSource.map((item, i) => {
          return {...item, _id: i};
        })}
        rowKey="_id"
        columns={columns}
        pagination={false}
        scroll={{x: 'max-content', y: 200}}
      />
    </div>
  );
};

export default ActionItems;
